import "core-js/modules/es6.string.small";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import delay from 'lodash/delay';
import { formatPrismicImage } from '~/helpers/image-helper';
import Cta from '~/components/atoms/Cta.vue';
import Glide from '~/components/functional/UI/Glide.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-left-doodle.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';
import RegularTitle from '~/components/atoms/Global/RegularTitle.vue';
import RegularSubtitle from '~/components/atoms/Global/RegularSubtitle.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
var SLOW_TIMER = 7000;
var AUTOPLAY_TIMER = 5000;
export default {
  name: 'SliderWithCta',
  components: {
    Glide: Glide,
    Cta: Cta,
    RegularTitle: RegularTitle,
    RegularSubtitle: RegularSubtitle,
    SimpleParagraph: SimpleParagraph
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      autoplay: false
    };
  },
  computed: {
    currentPayload: function currentPayload() {
      return {
        items: this.payload.items.map(function (item) {
          return {
            image: {
              small: {
                src: formatPrismicImage(item.image.small.url, ['w_375']),
                srcset: "".concat(formatPrismicImage(item.image.small.url, ['w_375']), " 375w,").concat(formatPrismicImage(item.image.small.url, ['w_375,dpr_2']), " 750w,").concat(formatPrismicImage(item.image.small.url, ['w_1440']), " 1440w")
              },
              medium: {
                src: formatPrismicImage(item.image.url, ['w_375,dpr_2']),
                srcset: "".concat(formatPrismicImage(item.image.url, ['w_375']), " 375w,").concat(formatPrismicImage(item.image.url, ['w_375,dpr_2']), " 750w,").concat(formatPrismicImage(item.image.url, ['w_1440']), " 1440w")
              },
              large: {
                src: formatPrismicImage(item.image.large.url, ['w_1440']),
                srcset: "".concat(formatPrismicImage(item.image.large.url, ['w_375']), " 375w,").concat(formatPrismicImage(item.image.large.url, ['w_375,dpr_2']), " 750w,").concat(formatPrismicImage(item.image.large.url, ['w_1440']), " 1440w")
              }
            },
            ctas: [{
              url: item.button_url_1.url || '',
              textBtn: item.button_text_1 || '',
              type: item.button_type_1 || 'primary'
            }, {
              url: item.button_url_2.url || '',
              textBtn: item.button_text_2 || '',
              type: item.button_type_2 || 'primary'
            }, {
              url: item.button_url_3.url || '',
              textBtn: item.button_text_3 || '',
              type: item.button_type_3 || 'primary'
            }, {
              url: item.button_url_4.url || '',
              textBtn: item.button_text_4 || '',
              type: item.button_type_4 || 'primary'
            }, {
              url: item.button_url_5.url || '',
              textBtn: item.button_text_5 || '',
              type: item.button_type_5 || 'primary'
            }, {
              url: item.button_url_6.url || '',
              textBtn: item.button_text_6 || '',
              type: item.button_type_6 || 'primary'
            }].filter(function (filteredItem) {
              return filteredItem.textBtn;
            })
          };
        })
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    delay(function () {
      _this.autoplay = AUTOPLAY_TIMER;

      if (_this.$refs.glide) {
        _this.$refs.glide.$el.classList.add('playing');
      }
    }, SLOW_TIMER);
  }
};